import { useCallback, useEffect, useState } from 'react'
import { Box, CssBaseline } from '@mui/material'
import EnterEmail from './components/EnterEmail'
import VerifyOTP from './components/VerifyOTP'
import CreateUserProfile from './components/CreateUserPerfile'
import OnboardCompany from './components/OnboardCompany'
import { useNavigate, useSearchParams } from 'react-router-dom'
import WaveBackground from './components/WaveBackground'
import { Container } from '@mui/material'

import './Signup.css'

export const STAGES = {
  ENTER_EMAIL: 'enter-email',
  VERIFY_EMAIL: 'verify-email',
  ENTER_USER_DETAILS: 'enter-user-details',
  ONBOARD_COMPANY: 'onboard-company',
}

const Signup = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const stage = searchParams.get('stage')

  const [isSticky, setIsSticky] = useState(false)

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsSticky(true)
    } else {
      setIsSticky(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const [onboardingStatus, setOnboardingStatus] = useState({
    [STAGES.ENTER_EMAIL]: false,
    [STAGES.VERIFY_EMAIL]: false,
    [STAGES.ENTER_USER_DETAILS]: false,
    [STAGES.ONBOARD_COMPANY]: false,
  })

  const [userDetails, setUserDetails] = useState({})
  const [companyDetails, setCompanyDetails] = useState({})

  const [isLoading, setLoading] = useState(false)

  const navigateToScreenId = useCallback(
    (stage) => {
      navigate(`/signup?stage=${stage}`)
    },
    [navigate]
  )

  // append step in case step is missing in url
  useEffect(() => {
    if (!stage) {
      navigateToScreenId(STAGES.ENTER_EMAIL)
    } else {
      // check if previous steps are done or not before rendering the actual screen
      switch (stage) {
        case STAGES.VERIFY_EMAIL:
          if (onboardingStatus[STAGES.ENTER_EMAIL]) {
            navigateToScreenId(stage)
          } else {
            navigateToScreenId(STAGES.ENTER_EMAIL)
          }
          break

        case STAGES.ENTER_USER_DETAILS:
          if (onboardingStatus[STAGES.VERIFY_EMAIL]) {
            navigateToScreenId(stage)
          } else {
            navigateToScreenId(STAGES.ENTER_EMAIL)
          }
          break

        case STAGES.ONBOARD_COMPANY:
          if (onboardingStatus[STAGES.ENTER_USER_DETAILS]) {
            navigateToScreenId(stage)
          } else {
            navigateToScreenId(STAGES.ENTER_EMAIL)
          }
          break

        default:
          navigateToScreenId(STAGES.ENTER_EMAIL)
      }
    }
  }, [navigateToScreenId, onboardingStatus, searchParams, stage])

  const renderScreen = (stage) => {
    switch (stage) {
      case STAGES.ENTER_EMAIL:
        return (
          <EnterEmail
            userDetails={userDetails}
            setUserDetails={setUserDetails}
            isLoading={isLoading}
            navigateToScreen={(index) => {
              setOnboardingStatus({ ...onboardingStatus, [STAGES.ENTER_EMAIL]: true })
              navigateToScreenId(index)
            }}
          />
        )
      case STAGES.VERIFY_EMAIL:
        return (
          <VerifyOTP
            userDetails={userDetails}
            setUserDetails={setUserDetails}
            isLoading={isLoading}
            navigateToScreen={(index) => {
              setOnboardingStatus({ ...onboardingStatus, [STAGES.VERIFY_EMAIL]: true })
              navigateToScreenId(index)
            }}
          />
        )
      case STAGES.ENTER_USER_DETAILS:
        return (
          <CreateUserProfile
            userDetails={userDetails}
            setUserDetails={setUserDetails}
            isLoading={isLoading}
            navigateToScreen={(index) => {
              setOnboardingStatus({ ...onboardingStatus, [STAGES.ENTER_USER_DETAILS]: true })
              navigateToScreenId(index)
            }}
          />
        )
      case STAGES.ONBOARD_COMPANY:
        return (
          <OnboardCompany
            userDetails={userDetails}
            setUserDetails={setUserDetails}
            companyDetails={companyDetails}
            setCompanyDetails={setCompanyDetails}
            isLoading={isLoading}
            setLoading={setLoading}
            navigateToScreen={(index) => {
              setOnboardingStatus({ ...onboardingStatus, [STAGES.ONBOARD_COMPANY]: true })
              navigateToScreenId(index)
            }}
          />
        )
      default:
        return <></>
    }
  }

  return (
    <Box
      className="landing-page"
      style={{
        padding: 24,
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        backgroundColor: '#fdfdfd',
      }}
    >
      <WaveBackground />

      <nav className={`navbar navbar-expand-lg navbar-light ${isSticky ? 'sticky' : 'notify-bx'}`}>
        <Container maxWidth="lg">
          <div className="navbar-brand" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
            <img src="/branding/e7_logo_black.png" alt="epoch7 logo" style={{ width: '109px' }} />
          </div>
        </Container>
      </nav>
      <CssBaseline />
      <Box style={{ width: 500, minHeight: '100%', zIndex: 1 }}>{renderScreen(stage)}</Box>
    </Box>
  )
}

export default Signup
